<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeSuEditUserDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            <span>
                {{ "su-management.users.edit-user" | translate }}
            </span>
            <span class="zx-100-opp">-</span>
            <span>-</span>
            <span class="zx-100-opp">-</span>
            <span>{{ user.email }}</span>
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            <form class="d-flex flex-column gap-4 px-1 py-2 px-lg-5 pt-lg-0 w-100" [formGroup]="form"
                (submit)="onSaveUser()">

                <!-- FIELD ================= - DISPLAY NAME -->
                <div class="d-flex justify-content-between w-100 align-items-center gap-2 gap-lg-3">
                    <span>
                        <span>
                            <b>
                                {{ "my-profile.username" | translate }}
                            </b>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <div class="profileItem-displayName d-flex align-items-center gap-2 gap-lg-3"
                        (click)="toggleField('displayName')">
                        <span class="zx-text-medium zx-text-sm-big">
                            {{ user.displayName }}
                        </span>
                        <!-- etit icon -->
                        <div class="px-2 d-flex justify-content-center c-pointer">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                                class="svg zx-small-icon-size c-pointer">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                                class="svg zx-small-icon-size c-pointer">
                        </div>
                    </div>
                    <!-- inner FIELD - displayName -->
                    <mat-form-field class="profileField-displayName d-none flex-grow-1 position-relative zx-z-index-1">
                        <mat-label [class.zx-text-white]="isDarkMode">
                            {{ "my-profile.username" | translate }}
                        </mat-label>
                        <input [class.d-none]="isLoadingUpdates" matInput type="text" formControlName="displayName"
                            [placeholder]="'my-profile.username' | translate" required>
                        <div [class.d-none]="!isLoadingUpdates"
                            class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                            <mat-spinner class="zx-small-icon-size"></mat-spinner>
                        </div>
                        <mat-error [class.zx-text-white]="isDarkMode" *ngIf="form.get('displayName').invalid">
                            {{ "my-profile.username.error" | translate }}
                        </mat-error>
                        <!-- clear field -->
                        <div class="position-absolute d-flex justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                            [class.top-clear-field-not-rtl]="!isRTL">
                            <div matRipple (click)="toggleField('displayName')"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer"
                                    [class.zx-text-gray-dark]="isDarkMode">close</mat-icon>
                            </div>
                        </div>
                        <!-- // clear field -->
                        <!-- save btn displayName -->
                        <button type="button" (click)="onSaveUser()"
                            *ngIf="user.displayName !== form.get('displayName').value  && !form.get('displayName').invalid"
                            class="w-100 py-1 py-lg-2 rounded-3 mt-2 mt-lg-3" mat-stroked-button color="primary">
                            {{ "my-profile.save-chainges" | translate }}
                        </button>
                        <!-- // save btn displayName -->
                    </mat-form-field>
                    <!-- // inner FIELD - displayName -->

                </div>
                <!-- // ================= FIELD - DISPLAY NAME -->

                <!-- ================= FIELD - EMAIL -->
                <div class="d-flex justify-content-between w-100 align-items-center gap-2 gap-lg-3">
                    <span>
                        <span>
                            <b>
                                {{ "my-profile.email" | translate }}
                            </b>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <div class="profileItem-email d-flex align-items-center gap-2 gap-lg-3"
                        (click)="toggleField('email')">
                        <span class="zx-text-medium zx-text-sm-big">
                            {{ user.email }}
                        </span>
                        <!-- etit icon -->
                        <div class="px-2 d-flex justify-content-center c-pointer">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                                class="svg zx-small-icon-size c-pointer">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                                class="svg zx-small-icon-size c-pointer">
                        </div>
                    </div>
                    <!-- inner FIELD - email -->
                    <mat-form-field class="profileField-email d-none flex-grow-1 position-relative zx-z-index-1">
                        <mat-label [class.zx-text-white]="isDarkMode">
                            {{ "my-profile.email" | translate }}
                        </mat-label>
                        <input [class.d-none]="isLoadingUpdates" matInput type="text" formControlName="email"
                            [placeholder]="'my-profile.email' | translate" required email>
                        <div [class.d-none]="!isLoadingUpdates"
                            class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                            <mat-spinner class="zx-small-icon-size"></mat-spinner>
                        </div>
                        <mat-error [class.zx-text-white]="isDarkMode" *ngIf="form.get('email').invalid"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            {{ "log-in-dialog-mailexist-mail-not-valid" | translate }}
                        </mat-error>
                        <!-- clear field -->
                        <div class="position-absolute d-flex justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                            [class.top-clear-field-not-rtl]="!isRTL">
                            <div matRipple (click)="toggleField('email')"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer">close</mat-icon>
                            </div>
                        </div>
                        <!-- // clear field -->
                        <!-- save btn email -->
                        <button type="button" (click)="onSaveUser()"
                            *ngIf="user.email !== form.get('email').value  && !form.get('email').invalid"
                            class="w-100 py-1 py-lg-2 rounded-3 mt-2 mt-lg-3" mat-stroked-button color="primary">
                            {{ "my-profile.save-chainges" | translate }}
                        </button>
                        <!-- // save btn email -->
                    </mat-form-field>
                    <!-- // inner FIELD - email -->
                </div>
                <!-- // ================= FIELD - EMAIL -->

                <!-- ================= FIELD - PHONE -->
                <div class="d-flex justify-content-between w-100 align-items-center gap-2 gap-lg-3">
                    <span>
                        <span>
                            <b>
                                {{ "my-profile.phone" | translate }}
                            </b>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <div class="profileItem-phone d-flex align-items-center gap-2 gap-lg-3"
                        (click)="toggleField('phone')">
                        <div *ngIf="user.phone" class="zx-text-medium zx-text-sm-big d-flex align-items-center"
                            [class.flex-row-reverse]="isRTL">
                            <span>0</span>
                            <span>
                                {{ ('0' + user.phone.toString()).slice(1, 3) }}
                            </span>
                            <span>-</span>
                            <span>
                                {{ ('0' + user.phone.toString()).slice(3, 7) }}
                            </span>
                            <span>-</span>
                            <span>
                                {{ ('0' + user.phone.toString()).slice(7) }}
                            </span>
                        </div>
                        <div *ngIf="!user.phone" class="zx-text-medium zx-text-sm-big d-flex align-items-center"
                            [class.flex-row-reverse]="isRTL">
                            <span [class.text-red]="!isDarkMode">
                                {{ "my-profile.not-exist" | translate }}
                            </span>
                        </div>
                        <!-- etit icon -->
                        <div class="px-2 d-flex justify-content-center c-pointer">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                                class="svg zx-small-icon-size c-pointer">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                                class="svg zx-small-icon-size c-pointer">
                        </div>
                    </div>
                    <!-- inner FIELD - phone -->
                    <mat-form-field class="profileField-phone d-none flex-grow-1 position-relative zx-z-index-1">
                        <mat-label [class.zx-text-white]="isDarkMode">
                            {{ "my-profile.phone" | translate }}
                        </mat-label>
                        <input [class.d-none]="isLoadingUpdates" matInput type="text" formControlName="phone"
                            [placeholder]="'my-profile.phone' | translate" required appPhoneFormat inputmode="numeric">
                        <div [class.d-none]="!isLoadingUpdates"
                            class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                            <mat-spinner class="zx-small-icon-size"></mat-spinner>
                        </div>
                        <mat-error [class.zx-text-white]="isDarkMode" *ngIf="form.get('phone').invalid"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            {{ "my-profile.phone.error" | translate }}
                        </mat-error>
                        <!-- clear field -->
                        <div class="position-absolute d-flex justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                            [class.top-clear-field-not-rtl]="!isRTL">
                            <div matRipple (click)="toggleField('phone')"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer">close</mat-icon>
                            </div>
                        </div>
                        <!-- // clear field -->
                        <!-- save btn phone -->
                        <button type="button" (click)="onSaveUser()"
                            *ngIf="comperePhoneNumbers(user.phone, form.get('phone').value) && !form.get('phone').invalid"
                            class="w-100 py-1 py-lg-2 rounded-3 mt-2 mt-lg-3" mat-stroked-button color="primary">
                            {{ "my-profile.save-chainges" | translate }}
                        </button>
                        <!-- // save btn phone -->
                    </mat-form-field>
                    <!-- // inner FIELD - phone -->
                </div>
                <!-- // ================= FIELD - PHONE -->

                <!-- ================= FIELD - CREADIT -->
                <div class="d-flex justify-content-between w-100 align-items-center gap-2 gap-lg-3">
                    <span>
                        <span>
                            <b>
                                {{ "my-profile.credit" | translate }}
                            </b>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <!-- card exist -->
                    <div class="d-flex align-items-center gap-2 gap-lg-3">
                        <!-- card exist -->
                        <div *ngIf="user.zCreditInfo && user.zCreditInfo.cardNum"
                            class="zx-text-medium zx-text-sm-big d-flex align-items-center"
                            [class.flex-row-reverse]="!isRTL">
                            <span>
                                {{ user.zCreditInfo.cardNum }}
                            </span>
                            <span class="zx-100-opp">_</span>
                            <span>****</span>
                            <span class="zx-100-opp">_</span>
                            <span>****</span>
                            <span class="zx-100-opp">_</span>
                            <span>****</span>
                        </div>
                        <!-- etit icon -->
                        <div *ngIf="user.zCreditInfo && user.zCreditInfo.cardNum" [matMenuTriggerFor]="deleteCCManu"
                            class="px-2 d-flex justify-content-center c-pointer">
                            <mat-icon class="text-red m-0 p-0 zx-pt-small"
                                [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                        </div>
                        <mat-menu #deleteCCManu="matMenu">
                            <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                                (click)="onDeleteCCUser()">
                                <b class="text-red zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                    {{'my-cc-delete-card-for-good'
                                    | translate}}
                                </b>
                                <mat-icon class="text-red mx-1 p-0 zx-pt-small"
                                    [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                            </button>
                        </mat-menu>
                        <!-- card not exist -->
                        <div *ngIf="!(user.zCreditInfo && user.zCreditInfo.cardNum)"
                            class="zx-text-medium zx-text-sm-big d-flex align-items-center px-2"
                            [class.flex-row-reverse]="!isRTL">
                            <span>
                                {{ "su-management.not-existing" | translate }}
                            </span>
                        </div>
                    </div>
                    <!-- card exist -->

                    <!-- // inner FIELD - credit -->
                </div>
                <!-- // ================= FIELD - CREADIT -->

                <!-- ================= FIELD - DISCOUNT -->
                <div class="d-flex justify-content-between w-100 align-items-center gap-2 gap-lg-3">
                    <span>
                        <span>
                            <b>
                                {{ "my-profile.permanent-discount" | translate }}
                            </b>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <div class="profileItem-discount d-flex align-items-center gap-2 gap-lg-3"
                        (click)="toggleField('discount')">
                        <div *ngIf="user.discount" class="zx-text-medium zx-text-sm-big d-flex align-items-end">
                            <span *ngIf="user.discount < 100">
                                {{ user.discount }}%
                            </span>
                            <span *ngIf="user.discount === 100">
                                {{ "my-profile.payment-per-lap" | translate }}
                            </span>
                        </div>
                        <div *ngIf="!user.discount || user.discount === 0"
                            class="zx-text-medium zx-text-sm-big d-flex align-items-center"
                            [class.flex-row-reverse]="isRTL">
                            <span>
                                0%
                            </span>
                        </div>
                        <!-- etit icon -->
                        <div class="px-2 d-flex justify-content-center c-pointer">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                                class="svg zx-small-icon-size c-pointer">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                                class="svg zx-small-icon-size c-pointer">
                        </div>
                    </div>
                    <!-- inner FIELD - discount -->
                    <mat-form-field class="profileField-discount d-none flex-grow-1 position-relative zx-z-index-1">
                        <mat-label [class.zx-text-white]="isDarkMode">
                            {{ "my-profile.permanent-discount" | translate }}
                        </mat-label>
                        <input [class.d-none]="isLoadingUpdates" matInput type="number" formControlName="discount"
                            [placeholder]="'my-profile.permanent-discount' | translate" required inputmode="numeric">
                        <div [class.d-none]="!isLoadingUpdates"
                            class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                            <mat-spinner class="zx-small-icon-size"></mat-spinner>
                        </div>
                        <mat-error [class.zx-text-white]="isDarkMode" *ngIf="form.get('discount').invalid"
                            [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                            {{ "my-profile.permanent-discount.error" | translate }}
                        </mat-error>
                        <!-- clear field -->
                        <div class="position-absolute d-flex justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                            [class.top-clear-field-not-rtl]="!isRTL">
                            <div matRipple (click)="toggleField('discount')"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer">close</mat-icon>
                            </div>
                        </div>
                        <!-- // clear field -->
                        <!-- save btn discount -->
                        <button type="button" (click)="onSaveUser()"
                            *ngIf="user.discount !== form.get('discount').value && !form.get('discount').invalid"
                            class="w-100 py-1 py-lg-2 rounded-3 mt-2 mt-lg-3" mat-stroked-button color="primary">
                            {{ "my-profile.save-chainges" | translate }}
                        </button>
                        <!-- // save btn discount -->
                    </mat-form-field>
                    <!-- // inner FIELD - discount -->
                </div>
                <!-- // ================= FIELD - DISCOUNT -->

                <!-- ================= FIELD - ROLES -->
                <div class="d-flex justify-content-between w-100 align-items-center gap-2 gap-lg-3">
                    <span>
                        <span>
                            <b>
                                {{ "my-profile.permissions" | translate }}
                            </b>
                            <span class="zx-100-opp">--</span>
                        </span>
                    </span>
                    <div class="profileItem-roles d-flex align-items-center gap-2 gap-lg-3"
                        (click)="toggleField('roles')">
                        <div class="zx-text-medium zx-text-sm-big d-flex align-items-end">
                            <span *ngFor="let role of user.roles, let i = index">
                                <span>
                                    {{ role }}
                                </span>
                                <span *ngIf="i < user.roles.length - 1">
                                    <span class="zx-100-opp">.</span>
                                    <span>,</span>
                                    <span class="zx-100-opp">.</span>
                                </span>
                            </span>
                        </div>
                        <!-- etit icon -->
                        <div class="px-2 d-flex justify-content-center c-pointer">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                                class="svg zx-small-icon-size c-pointer">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                                class="svg zx-small-icon-size c-pointer">
                        </div>
                    </div>
                    <!-- inner FIELD - roles -->
                    <mat-form-field class="profileField-roles d-none flex-grow-1 position-relative zx-z-index-1">
                        <mat-label [class.zx-text-white]="isDarkMode">
                            {{ "my-profile.permissions" | translate }}
                        </mat-label>
                        <mat-select *ngIf="!isLoadingUpdates" formControlName="roles" multiple>
                            <mat-option *ngFor="let role of rolesList" [value]="role">{{ role }}</mat-option>
                        </mat-select>
                        <div [class.d-none]="!isLoadingUpdates"
                            class="w-100 d-flex justify-content-center zx-min-h-input-spacer">
                            <mat-spinner class="zx-small-icon-size"></mat-spinner>
                        </div>
                        <!-- clear field -->
                        <div class="position-absolute d-flex justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                            [class.top-clear-field-not-rtl]="!isRTL">
                            <div matRipple (click)="toggleField('roles')"
                                class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                <mat-icon class="m-0 p-1 zx-text-medium c-pointer">close</mat-icon>
                            </div>
                        </div>
                        <!-- // clear field -->
                        <!-- save btn roles -->
                        <button type="button" (click)="onSaveUser()"
                            *ngIf="user.roles !== form.get('roles').value && !form.get('roles').invalid"
                            class="w-100 py-1 py-lg-2 rounded-3 mt-2 mt-lg-3" mat-stroked-button color="primary">
                            {{ "my-profile.save-chainges" | translate }}
                        </button>
                        <!-- // save btn roles -->
                    </mat-form-field>
                    <!-- // inner FIELD - roles -->
                </div>
                <!-- // ================= FIELD - ROLES -->

                <button #hiddenSubmitBtn type="submit" style="display: none;"></button>
            </form>

        </div>

    </div>
</div>